import { KIBANA_URL } from 'environment';

class ElasticsearchService {

    constructor($http) {
        this.$http = $http;
    }

    // Generate a list of ElasticSearch logs indices, assuming we have daily index rotation
    // Called by BroadcastGraph directive using broadcast.starts_at -> stops_at
    // Called by BoxCaster form controller to look at yesterday -> today
    formatIndices(fromDate, toDate = null) {
        const millisecondsPerDay = 24 * 60 * 60 * 1000;

        // Loop through from-to and build indices
        let indices = [this.getLogIndexForDate(fromDate)];
        if (toDate && (toDate > fromDate)) {
            // start with the first UTC moment of the _next_ calendar day after fromDate
            let dt = new Date((new Date(fromDate.getUTCFullYear(), fromDate.getUTCMonth(), fromDate.getUTCDate(), 0, 0, 0)).getTime() + millisecondsPerDay);
            while (true) {
                if ((dt.getTime() > (toDate.getTime() + millisecondsPerDay)) || (dt.getTime() > Date.now())) {
                    break;
                }
                let i = this.getLogIndexForDate(dt);
                if (!_.contains(indices, i)) {
                    indices.push(i);
                }
                dt = new Date(dt.getTime() + millisecondsPerDay);
            }
        }

        return indices;
    }

    getLogIndexForDate(dt) {
      // Don't try to query tomorrow before it actually exists
      // XXX: this is dependent on browser clock, which could be out
      // of sync, but it's the best we got for right now :(
      const now = new Date,
            nowUtc = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(),  now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds());
      if (dt > nowUtc) {
        dt = nowUtc;
      }
      const m = (dt.getMonth() + 1).toString(),
            ms = (m < 10 ? "0" + m : m),
            d = dt.getDate().toString(),
            ds = (d < 10 ? "0" + d : d);
      return `logs-${dt.getUTCFullYear()}-${ms}-${ds}`;
    }

    query(indices, q) {
        return this.$http.post(`${KIBANA_URL}/elasticsearch/${indices.join(',')}/_search`, q, {headers: {'kbn-version': '6.5.4' }, 'Interceptor-Ignore-Errors': true})
    }
}

angular.module('app.services').service('ElasticsearchService', ElasticsearchService);



// WEBPACK FOOTER //
// ./services/elasticsearch_service.js